import { createReducer } from '@reduxjs/toolkit';

import { modifyingStart, modifyingStop } from './modifying.actions';
import { IState } from './modifying.types';

export const initialState: IState = {
    isModifyingInProgress: false,
};

export const modifyingReducer = createReducer(initialState, {
    [modifyingStart.type]: (state) => {
        return {
            ...state,
            isModifyingInProgress: true,
        };
    },
    [modifyingStop.type]: (state) => {
        return {
            ...state,
            isModifyingInProgress: false,
        };
    },
});
